import React from "react";
import useStyles from "./styles";
import clsx from "clsx";
import { getSvgIcon } from "../../../svgUtility";
import { ICON } from "../../../constants";

function DrawerHeader(props) {
  const classes = useStyles();
  return (
    <>
      <div className={clsx(classes.flex, classes.justifyCenter)}>
        <div className={classes.bar}></div>
      </div>
      <div
        className={clsx(
          classes.flex,
          classes.alignCenter,
          classes.spaceBw,
          classes.marginHeadingDrawer
        )}
      >
        <h3 className={classes.drawerHeading}>{props.heading}</h3>
        <button
          onClick={() => {
            props.setDrawerOpen(false);
          }}
          className={clsx(classes.noBtn, classes.closeBtn)}
        >
          {getSvgIcon(ICON.CLOSE_ICON)}
        </button>
      </div>
      <hr className={classes.hr}></hr>
    </>
  );
}
export default DrawerHeader;
